import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [menuData, setMenuData] = useState({});
    const [openCategory, setOpenCategory] = useState(null);
    const [mobileProductsOpen, setMobileProductsOpen] = useState(false);

    useEffect(() => {
        const fetchMenu = async () => {
            try {
                const BASE_URL = window.location.hostname === 'localhost'
                    ? 'http://127.0.0.1:8003'
                    : 'https://rbmchemicals.com';

                const response = await fetch(`${BASE_URL}/api/get_menu/`);
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                setMenuData(data);
            } catch (err) {
                console.error("Error fetching menu:", err);
            }
        };
        fetchMenu();
    }, []);

    const handleLinkClick = () => {
        setIsOpen(false);
        setOpenCategory(null);
        setMobileProductsOpen(false);
    };

    return (
        <nav className="sticky top-0 z-50 w-full shadow-lg bg-white border-b border-gray-200">
            {/* Top Contact Bar */}
            <div className="hidden md:flex bg-gray-50 py-2 px-6 justify-end items-center text-sm text-gray-700">
                <span className="mr-8">📞 +91 9253412469 , +91 8905550315</span>
                <p className="mr-4">✉️ rbmchemicalsandsolutionsllp@gmail.com</p>
                <p className="mr-4">✉️ info@rbmchemicals.com</p>
                <p>✉️ rbmchemicalsandsolutionsllp@yahoo.com</p>
                <a
                    href="/rbm-catalogue.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-blue-900 text-white px-4 py-2 rounded ml-4 inline-flex items-center justify-center transition-all hover:bg-blue-800"
                >
                    Download Catalogue
                </a>
            </div>

            {/* Main Navigation */}
            <div className="px-4 py-3 flex items-center justify-between text-black relative">
                <img src="/rbm-logo.png" alt="Logo" className="w-40 md:w-52 h-auto object-contain" />

                <button className="md:hidden text-3xl font-bold text-black" onClick={() => setIsOpen(!isOpen)}>☰</button>

                <div className={`${isOpen ? 'flex' : 'hidden'} md:flex flex-grow flex-col md:flex-row absolute md:static top-full left-0 w-full md:w-auto bg-white p-6 md:p-0 space-y-4 md:space-y-0 md:space-x-8 text-lg font-extrabold items-center justify-center shadow-lg md:shadow-none`}>
                    <Link to="/" onClick={handleLinkClick} className="hover:text-orange-500 transition-colors">HOME</Link>
                    <Link to="/about" onClick={handleLinkClick} className="hover:text-orange-500 transition-colors">ABOUT</Link>

                    {/* Products Dropdown */}
                    <div className="relative group py-2 w-full md:w-auto text-center">
                        {/* Main Products Link & Separate Dropdown Toggle Button */}
                        <div className="flex items-center justify-center cursor-pointer hover:text-orange-500 transition-colors p-4 md:p-2">
                            <Link to="/products" onClick={handleLinkClick} className="font-extrabold">
                                PRODUCTS
                            </Link>
                            {/* Thoda dur aur alag arrow button mobile aur desktop dono ke liye */}
                            <span
                                className="ml-4 px-3 py-1 bg-gray-100 md:bg-transparent rounded font-bold text-xl select-none text-blue-900"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setMobileProductsOpen(!mobileProductsOpen);
                                }}
                            >
                                {mobileProductsOpen ? '▲' : '▼'}
                            </span>
                        </div>

                        {/* Dropdown Container */}
                        <div className={`absolute top-full left-1/2 -translate-x-1/2 md:translate-x-0 md:left-0 bg-white text-black w-72 shadow-2xl z-[1000] border border-gray-200 mt-0 text-left ${mobileProductsOpen ? 'block' : 'hidden'} md:hidden md:group-hover:block`}>
                            {menuData && Object.keys(menuData).length > 0 ? (
                                Object.entries(menuData).map(([cat, subs]) => (
                                    <div key={cat} className="border-b border-gray-100 hover:bg-gray-100 relative group/sub">

                                        {/* Category Title + Toggle Container */}
                                        <div className="flex justify-between items-center w-full px-2">
                                            <div className="flex-grow flex items-center py-3">
                                                <Link
                                                    to={`/category/${encodeURIComponent(cat)}`}
                                                    onClick={handleLinkClick}
                                                    className="font-bold text-base hover:text-blue-900 cursor-pointer w-full px-2"
                                                >
                                                    {cat}
                                                </Link>
                                            </div>

                                            {/* Toggle Arrow Button for Subcategories */}
                                            {subs && subs.length > 0 && (
                                                <div
                                                    className="px-4 py-3 ml-2 cursor-pointer font-bold text-blue-900 hover:bg-gray-200 rounded transition-colors select-none text-lg"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setOpenCategory(openCategory === cat ? null : cat);
                                                    }}
                                                >
                                                    {openCategory === cat ? '▼' : '▶'}
                                                </div>
                                            )}
                                        </div>

                                        {/* Subcategories Dropdown */}
                                        <div className={`bg-white md:absolute md:left-full md:top-0 md:hidden md:group-hover/sub:block w-72 shadow-2xl border ${openCategory === cat ? 'block' : 'hidden md:hidden'}`}>
                                            {subs && subs.map((sub, index) => (
                                                <Link
                                                    key={`${cat}-${index}`}
                                                    to={`/products/${encodeURIComponent(sub)}`}
                                                    onClick={handleLinkClick}
                                                    className="block p-4 hover:bg-blue-900 hover:text-white border-b border-gray-50 text-base font-normal cursor-pointer"
                                                >
                                                    {sub}
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="p-4 text-gray-400">Loading...</div>
                            )}
                        </div>
                    </div>

                    <Link to="/gallery" onClick={handleLinkClick} className="hover:text-orange-500 transition-colors">GALLERY</Link>
                    <Link to="/media" onClick={handleLinkClick} className="hover:text-orange-500 transition-colors">MEDIA</Link>
                    <Link to="/blog" onClick={handleLinkClick} className="hover:text-orange-500 transition-colors">BLOG</Link>
                    <Link to="/contact" onClick={handleLinkClick} className="hover:text-orange-500 transition-colors">CONTACT</Link>

                    <Link to="/enquiry" className="bg-orange-500 text-white px-6 py-2 rounded-full font-bold hover:bg-orange-600 transition-all text-lg" onClick={handleLinkClick}>
                        ENQUIRY
                    </Link>

                    {/* Mobile Only: Download Catalogue Button */}
                    <a
                        href="https://rbmchemicals.com/media/catalog.pdf"
                        download="RBM_Chemicals_Catalogue.pdf"
                        onClick={handleLinkClick}
                        className="md:hidden bg-blue-900 text-white px-6 py-2 rounded-full font-bold hover:bg-blue-800 transition-all text-lg"
                    >
                        Download Catalogue
                    </a>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;